import React, { useEffect } from 'react'
import { Row } from 'react-bootstrap'
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks'
import { getPaymentMethod, paymentMethodState } from '../paymentMethodSlice';

const PaymentMethodDisplay = () => {
  const dispatch = useAppDispatch();
  const { display: { isLoading, isSuccess, isError, data} } = useAppSelector(paymentMethodState)

  useEffect(() => {
    if(isError) {
      return
    }
    if(!isLoading && !isSuccess) {
        dispatch(getPaymentMethod());
    }
  }, [isLoading, isSuccess, isError])

  if(isLoading) {
     return (<SmashSpinner size='sm'/>)
  }

  if(isError) {
    return (<>No payment method for now</>)
 }

  return (
    <>
        <Row>
            <div><strong>Credit card number: </strong> **** **** **** {data?.last4}</div>
            <div><strong>Expiration date: </strong>{data?.expiryDate}</div>
        </Row>
    </>
  )
}

export default PaymentMethodDisplay